import { SAMPLE_IMAGE_SETS, getRandomImageSet } from './mockImages';
import { MOCK_USERS, CURRENT_USER } from './mockUsers';

// Sample comments pool
export const SAMPLE_COMMENTS = [
  {
    id: 1,
    user: { id: "user-10", name: "Alex Smith", avatar: "https://i.pravatar.cc/100?img=7" },
    text: "Looks amazing! Wish I was there.",
    likes: 4,
    isLikedByCurrentUser: false,
    createdAt: Date.now() - 3600000,
  },
  {
    id: 2,
    user: { id: "user-6", name: "Maria Lopez", avatar: "https://i.pravatar.cc/100?img=6" },
    text: "What a view! 😍",
    likes: 20,
    isLikedByCurrentUser: true,
    createdAt: Date.now() - 1800000,
  },
  {
    id: 3,
    user: { id: "user-2", name: "John Doe", avatar: "https://i.pravatar.cc/100?img=2" },
    text: "Beautiful place! Adding this to my bucket list.",
    likes: 12,
    isLikedByCurrentUser: false,
    createdAt: Date.now() - 7200000,
  },
  {
    id: 4,
    user: { id: "user-8", name: "Emma Wilson", avatar: "https://i.pravatar.cc/100?img=9" },
    text: "Thanks for sharing! 📸",
    likes: 8,
    isLikedByCurrentUser: true,
    createdAt: Date.now() - 2700000,
  },
  {
    id: 5,
    user: { id: "user-11", name: "David Chen", avatar: "https://i.pravatar.cc/100?img=3" },
    text: "I've been here before! It's even better in person.",
    likes: 15,
    isLikedByCurrentUser: false,
    createdAt: Date.now() - 10800000,
  },
  {
    id: 6,
    user: { id: "user-12", name: "Sophie Turner", avatar: "https://i.pravatar.cc/100?img=10" },
    text: "This is on my weekend itinerary now!",
    likes: 6,
    isLikedByCurrentUser: false,
    createdAt: Date.now() - 14400000,
  },
  {
    id: 7,
    user: { id: "user-13", name: "Ryan Garcia", avatar: "https://i.pravatar.cc/100?img=11" },
    text: "Anyone know the exact location?",
    likes: 3,
    isLikedByCurrentUser: true,
    createdAt: Date.now() - 18000000,
  },
  {
    id: 8,
    user: { id: "user-14", name: "Lisa Kim", avatar: "https://i.pravatar.cc/100?img=12" },
    text: "Stunning! What camera did you use?",
    likes: 9,
    isLikedByCurrentUser: false,
    createdAt: Date.now() - 21600000,
  },
  {
    id: 9,
    user: { id: "user-15", name: "Tom Brown", avatar: "https://i.pravatar.cc/100?img=13" },
    meta: "7h ago",
    text: "Adding this to my travel blog!",
    likes: 11,
    isLikedByCurrentUser: false,
    createdAt: Date.now() - 25200000,
  },
  {
    id: 10,
    user: { id: "user-16", name: "Anna White", avatar: "https://i.pravatar.cc/100?img=14" },
    text: "How long did you stay there?",
    likes: 2,
    isLikedByCurrentUser: true,
    createdAt: Date.now() - 28800000,
  },
  {
    id: 11,
    user: { id: "user-17", name: "Mike Johnson", avatar: "https://i.pravatar.cc/100?img=15" },
    text: "Perfect spot for sunset photos!",
    likes: 18,
    isLikedByCurrentUser: true,
    createdAt: Date.now() - 32400000,
  },
  {
    id: 12,
    user: { id: "user-18", name: "Sarah Davis", avatar: "https://i.pravatar.cc/100?img=16" },
    text: "Is this place pet-friendly?",
    likes: 5,
    isLikedByCurrentUser: false,
    createdAt: Date.now() - 36000000,
  },
  {
    id: 13,
    user: { id: "user-19", name: "Chris Lee", avatar: "https://i.pravatar.cc/100?img=17" },
    text: "I need to visit this place ASAP!",
    likes: 7,
    isLikedByCurrentUser: false,
    createdAt: Date.now() - 39600000,
  },
  {
    id: 14,
    user: { id: "user-20", name: "Nina Patel", avatar: "https://i.pravatar.cc/100?img=18" },
    text: "Such great vibes here!",
    likes: 14,
    isLikedByCurrentUser: true,
    createdAt: Date.now() - 43200000,
  },
  {
    id: 15,
    user: { id: "user-21", name: "Jake Miller", avatar: "https://i.pravatar.cc/100?img=19" },
    text: "Bookmarking for later!",
    likes: 10,
    isLikedByCurrentUser: false,
    createdAt: Date.now() - 46800000,
  },
  {
    id: 16,
    user: { id: "user-22", name: "Emily Stone", avatar: "https://i.pravatar.cc/100?img=20" },
    text: "What time of day is best to visit?",
    likes: 4,
    isLikedByCurrentUser: false,
    createdAt: Date.now() - 50400000,
  },
  {
    id: 17,
    user: { id: "user-23", name: "Oliver King", avatar: "https://i.pravatar.cc/100?img=21" },
    meta: "15h ago",
    text: "Love the atmosphere here!",
    likes: 13,
    isLikedByCurrentUser: true,
    createdAt: Date.now() - 54000000,
  },
  {
    id: 18,
    user: { id: "user-24", name: "Mia Taylor", avatar: "https://i.pravatar.cc/100?img=22" },
    meta: "16h ago",
    text: "This looks like paradise!",
    likes: 16,
    isLikedByCurrentUser: false,
    createdAt: Date.now() - 57600000,
  },
  {
    id: 19,
    user: { id: "user-25", name: "Liam Anderson", avatar: "https://i.pravatar.cc/100?img=23" },
    meta: "17h ago",
    text: "Great recommendation!",
    likes: 8,
    isLikedByCurrentUser: false,
    createdAt: Date.now() - 61200000,
  },
  {
    id: 20,
    user: { id: "user-26", name: "Zoe Martin", avatar: "https://i.pravatar.cc/100?img=24" },
    meta: "18h ago",
    text: "I'm definitely going this weekend!",
    likes: 12,
    isLikedByCurrentUser: true,
    createdAt: Date.now() - 64800000,
  },
];

// Helper to generate random coordinates near a point
function nearbyCoords(lat, lng, radiusKm = 2) {
  const radiusInDegrees = radiusKm / 111; // Rough conversion
  const u = Math.random();
  const v = Math.random();
  const w = radiusInDegrees * Math.sqrt(u);
  const t = 2 * Math.PI * v;
  const x = w * Math.cos(t);
  const y = w * Math.sin(t);
  return {
    latitude: lat + x,
    longitude: lng + y,
  };
}

// Helper to generate multiple comments for testing pagination
function generateComments(count) {
  const comments = [];
  const baseTime = Date.now();
  
  for (let i = 0; i < count; i++) {
    const commentTemplate = SAMPLE_COMMENTS[i % SAMPLE_COMMENTS.length];
    const createdAt = baseTime - (i * 3600000); // Each hour older
    
    // Generate likes count first
    const likes = Math.floor(Math.random() * 25);
    
    // Only set isLikedByCurrentUser if there are likes
    const isLikedByCurrentUser = likes > 0 && Math.random() > 0.7;
    
    comments.push({
      id: `comment-${Date.now()}-${i}`,
      user: commentTemplate.user,
      text: commentTemplate.text,
      likes,
      isLikedByCurrentUser,
      createdAt,
    });
  }
  
  return comments;
}

// Generate mock notes for current user (My Notes)
export function generateMyNotes(count = 15) {
  const baseLocation = { lat: 37.503, lng: -121.943 }; // Fremont area
  
  return Array.from({ length: count }, (_, i) => {
    const coords = nearbyCoords(baseLocation.lat, baseLocation.lng, 5);
    const visibility = i % 3 === 0 ? 'private' : 'public';
    const hasImages = Math.random() > 0.2;
    const images = hasImages ? getRandomImageSet() : [];
    const createdAt = Date.now() - Math.random() * 86400000 * 7; // Random within week
    
    // Generate 25-35 comments for better testing (first few notes have more comments)
    const commentCount = i < 3 ? Math.floor(Math.random() * 11) + 25 : Math.floor(Math.random() * 20);
    const comments = generateComments(commentCount);
    
    // Generate likes count first
    const likes = Math.floor(Math.random() * 50);
    
    // Only set isLikedByCurrentUser if there are likes
    const isLikedByCurrentUser = likes > 0 && Math.random() > 0.1;
    
    return {
      id: `my-${i + 1}`,
      owner: {
        id: CURRENT_USER.id,
        name: CURRENT_USER.name,
        avatar: CURRENT_USER.avatar,
      },
      title: `Lorem ipsum dolor sit amet`,
      body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      address: `${Math.floor(Math.random() * 9999)} Main St, Fremont, CA`,
      latitude: coords.latitude,
      longitude: coords.longitude,
      visibility,
      locationPrecision: Math.random() > 0.6 ? "approximate" : "exact",
      showAddress: Math.random() > 0.2,
      isOwner: true,
      images,
      stats: {
        likes,
        comments: comments.length,
      },
      isLikedByCurrentUser,
      isViewedByCurrentUser: true, // Own notes are always "viewed"
      comments,
      createdAt,
    };
  });
}

// Generate notes from other users (for nearby/home feed)
export function generateNearbyNotes(centerLat, centerLng, count = 20) {
  return Array.from({ length: count }, (_, i) => {
    const coords = nearbyCoords(centerLat, centerLng, 2); // Within 2km
    const randomUser = MOCK_USERS[Math.floor(Math.random() * MOCK_USERS.length)];
    const isMyNote = Math.random() > 0.7; // 30% chance it's user's own note
    const hasImages = Math.random() > 0.3;
    const images = hasImages ? getRandomImageSet() : [];
    const createdAt = Date.now() - Math.random() * 86400000 * 3; // Random within 3 days
    
    const owner = isMyNote ? {
      id: CURRENT_USER.id,
      name: CURRENT_USER.name,
      avatar: CURRENT_USER.avatar,
    } : {
      id: randomUser.id,
      name: randomUser.name,
      avatar: randomUser.avatar,
    };
    
    // Generate 12-25 comments for testing pagination
    const commentCount = i < 5 ? Math.floor(Math.random() * 14) + 12 : Math.floor(Math.random() * 20);
    const comments = generateComments(commentCount);
    
    // Generate likes count first
    const likes = Math.floor(Math.random() * 100);
    
    // Only set isLikedByCurrentUser if there are likes
    const isLikedByCurrentUser = likes > 0 && Math.random() > 0.6;
    
    return {
      id: `nearby-${i + 1}`,
      owner,
      title: `${isMyNote ? 'My' : owner.name + "'s"} Discovery`,
      body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      address: `${Math.floor(Math.random() * 9999)} Street, Fremont, CA`,
      latitude: coords.latitude,
      longitude: coords.longitude,
      visibility: 'public',
      locationPrecision: Math.random() > 0.5 ? "approximate" : "exact",
      showAddress: Math.random() > 0.15,
      isOwner: isMyNote,
      images,
      stats: {
        likes,
        comments: comments.length,
      },
      isLikedByCurrentUser,
      isViewedByCurrentUser: isMyNote || Math.random() > 0.3, // ~30% of others' notes unviewed
      comments,
      createdAt,
    };
  });
}
